<ng-container *ngIf="banners.length">
  <neb-banner __neb_ui_lit_component class="w-100 banners"
    [useIsolatedBootstrapStyles]="true"
    [banners]="banners">
  </neb-banner>
</ng-container>
